import { Controller } from "@hotwired/stimulus"

// Donut chart controller for hover tooltips
export default class extends Controller {
  static targets = ["tooltip", "segment", "center"]
  static values = {
    default: String
  }

  connect() {
    this.defaultText = this.defaultValue || ""
    if (this.hasCenterTarget) {
      this.defaultText = this.centerTarget.textContent
    }
  }

  showTooltip(event) {
    const segment = event.currentTarget
    const label = segment.dataset.label
    const percentage = segment.dataset.percentage
    const count = segment.dataset.count
    
    if (this.hasTooltipTarget) {
      this.tooltipTarget.textContent = `${label}: ${count} (${percentage}%)`
      this.tooltipTarget.classList.remove('hidden')
    }
    
    if (this.hasCenterTarget) {
      this.centerTarget.innerHTML = `<span class="text-2xl font-bold">${percentage}%</span><span class="text-xs text-slate-500 block">${label}</span>`
    }
  }

  hideTooltip() {
    if (this.hasTooltipTarget) {
      this.tooltipTarget.classList.add('hidden')
    }
    
    if (this.hasCenterTarget) {
      this.centerTarget.innerHTML = this.defaultText
    }
  }
}



